import { routePaths } from './basePaths';

export const bucketPaths = [
  {
    path: routePaths.InspectionBasePath + '/bucket',
    lazy: async () => {
      const { BucketSelectionScreen } =
        await import('../pages/inspections/bucket/BucketSelectionScreen');
      return {
        element: <BucketSelectionScreen />,
      };
    },
  },
  {
    path: routePaths.InspectionBasePath + '/bucket/new-bucket',
    lazy: async () => {
      const { NewBucket } =
        await import('../pages/inspections/bucket/NewBucket');
      return {
        element: <NewBucket />,
      };
    },
  },
  {
    path: routePaths.InspectionBasePath + '/bucket/:bucketExternalId',
    children: [
      {
        path: '',
        lazy: async () => {
          const { BucketTableOfContents } =
            await import('../pages/inspections/bucket/BucketTableOfContents');
          return {
            element: <BucketTableOfContents />,
          };
        },
      },
      {
        path: 'specifications',
        lazy: async () => {
          const { BucketSpecificationsFactoryScreen } =
            await import('../pages/inspections/bucket/BucketSpecificationsFactoryScreen');
          return {
            element: <BucketSpecificationsFactoryScreen />,
          };
        },
      },
      {
        path: 'summary',
        lazy: async () => {
          const { SummaryScreen } = await import('../pages/SummaryScreen');
          return {
            element: <SummaryScreen />,
          };
        },
      },
      {
        path: 'rotation/:bucketChangeToExternalId',
        lazy: async () => {
          const { BucketRotationScreen } =
            await import('../pages/inspections/bucket/BucketRotationScreen');
          return {
            element: <BucketRotationScreen />,
          };
        },
      },
      {
        path: 'ground-engaging-tools',
        children: [
          {
            path: '',
            lazy: async () => {
              const { BucketGETTableOfContents } =
                await import('../pages/inspections/bucket/get/BucketGETTableOfContents');
              return {
                element: <BucketGETTableOfContents />,
              };
            },
          },
          {
            path: 'summary',
            lazy: async () => {
              const { SummaryScreen } = await import('../pages/SummaryScreen');
              return {
                element: <SummaryScreen />,
              };
            },
          },
          {
            path: 'multiSelect',
            lazy: async () => {
              const BucketGETPartTypeChangeoutAndConditionScreenFactory = (
                await import('../pages/inspections/bucket/get/BucketGETPartTypeChangeoutAndConditionScreenFactory')
              ).default;
              return {
                element: (
                  <BucketGETPartTypeChangeoutAndConditionScreenFactory />
                ),
              };
            },
          },
          {
            path: 'part-types/:bucketPartTypeName',
            children: [
              {
                path: '',
                lazy: async () => {
                  const { BucketGETPartTypeScreen } =
                    await import('../pages/inspections/bucket/get/BucketGETPartTypeScreen');
                  return {
                    element: <BucketGETPartTypeScreen />,
                  };
                },
              },
              {
                path: 'summary',
                lazy: async () => {
                  const { SummaryScreen } =
                    await import('../pages/SummaryScreen');
                  return {
                    element: <SummaryScreen />,
                  };
                },
              },
              {
                path: ':bucketEquipmentPartId',
                lazy: async () => {
                  const BucketGETPartTypeChangeoutAndConditionScreenFactory = (
                    await import('../pages/inspections/bucket/get/BucketGETPartTypeChangeoutAndConditionScreenFactory')
                  ).default;
                  return {
                    element: (
                      <BucketGETPartTypeChangeoutAndConditionScreenFactory />
                    ),
                  };
                },
              },
            ],
          },
        ],
      },
      {
        path: 'wear-kit',
        children: [
          {
            path: '',
            lazy: async () => {
              const WearKitTableOfContents = (
                await import('../pages/inspections/bucket/wearKit/WearKitTableOfContents')
              ).default;
              return {
                element: <WearKitTableOfContents />,
              };
            },
          },
          {
            path: 'summary',
            lazy: async () => {
              const { SummaryScreen } = await import('../pages/SummaryScreen');
              return {
                element: <SummaryScreen />,
              };
            },
          },
          {
            path: 'wear-plates',
            children: [
              {
                path: '',
                lazy: async () => {
                  const WearPlatesPrimaryLocationsScreen = (
                    await import('../pages/inspections/bucket/wearKit/WearPlatesPrimaryLocationsScreen')
                  ).default;
                  return {
                    element: <WearPlatesPrimaryLocationsScreen />,
                  };
                },
              },
              {
                path: 'summary',
                lazy: async () => {
                  const { SummaryScreen } =
                    await import('../pages/SummaryScreen');
                  return {
                    element: <SummaryScreen />,
                  };
                },
              },
              {
                path: 'locations/:wearPlateLocationId',
                children: [
                  {
                    path: '',
                    lazy: async () => {
                      const WearPlatesSecondaryLocationFactoryScreen = (
                        await import('../pages/inspections/bucket/wearKit/WearPlatesSecondaryLocationFactoryScreen')
                      ).default;
                      return {
                        element: <WearPlatesSecondaryLocationFactoryScreen />,
                      };
                    },
                  },
                  {
                    path: 'summary',
                    lazy: async () => {
                      const { SummaryScreen } =
                        await import('../pages/SummaryScreen');
                      return {
                        element: <SummaryScreen />,
                      };
                    },
                  },
                  {
                    path: 'locations/:wearPlateSecondaryLocationId',
                    lazy: async () => {
                      const WearPlateObservationScreen = (
                        await import('../pages/inspections/bucket/wearKit/WearPlatesObservationScreen')
                      ).default;
                      return {
                        element: <WearPlateObservationScreen />,
                      };
                    },
                  },
                ],
              },
            ],
          },
          {
            path: 'heel-shrouds',
            children: [
              {
                path: '',
                lazy: async () => {
                  const HeelShroudsObservationScreen = (
                    await import('../pages/inspections/bucket/wearKit/heelShrouds/HeelShroudsObservationScreen')
                  ).default;
                  return {
                    element: <HeelShroudsObservationScreen />,
                  };
                },
              },
            ],
          },
        ],
      },
    ],
  },
];
